import { Route } from '@angular/router';
import { PolicyListComponent } from './ui/policy-list/policy-list.component';
import { PolicyDetailComponent } from './ui/policy-detail/policy-detail.component';
import { CheckoutComponent } from './ui/payments/checkout/checkout.component';

const policiesRoutes: Route[] = [
  {
    path: 'policies',
    component: PolicyListComponent,
  },
  {
    path: 'policy/:type/:policyNumber/:slob/detail',
    component: PolicyDetailComponent,
  },
  {
    path: 'checkout',
    component: CheckoutComponent,
  },
];

export default policiesRoutes;
